import { DynamicSEO } from '../components/seo';
import Layout from '../components/Layout';

export default function AboutPage() {
  return (
    <Layout>
      <DynamicSEO
        meta={{
          title: "About NameExplorer - Discover Nepali Names and Their Meanings",
          description: "Learn about NameExplorer's mission to preserve and share the rich cultural heritage of Nepali names and their meanings.",
          type: "website"
        }}
      />
      
      <div className="max-w-4xl mx-auto px-4 py-12">
        <h1 className="text-4xl font-bold text-gray-900 mb-8">About NameExplorer</h1>
        
        <div className="prose prose-lg">
          <p className="text-gray-600 mb-6">
            NameExplorer is dedicated to preserving and sharing the rich cultural heritage
            of Nepali names. Our mission is to help people discover the deep meanings and
            cultural significance behind traditional Nepali names.
          </p>

          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Our Mission</h2>
          <p className="text-gray-600 mb-6">
            We strive to create a comprehensive database of Nepali names, their meanings,
            and cultural significance. Our goal is to help both Nepali families and
            people worldwide understand the beauty and depth of Nepali naming traditions.
          </p>

          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">What We Offer</h2>
          <ul className="list-disc pl-6 text-gray-600 mb-6">
            <li>Comprehensive database of Nepali names</li>
            <li>Detailed meanings and cultural significance</li>
            <li>Name compatibility matching</li>
            <li>Traditional wisdom and quotes</li>
            <li>Cultural insights and traditions</li>
          </ul>
        </div>
      </div>
    </Layout>
  );
}